"use client";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
import { AiOutlinePauseCircle, AiOutlinePlayCircle } from "react-icons/ai";
import { VideoModulePropsModel } from "./VideoModule.model";

const VideoModule = ({
  name,
  videoUrl,
  video,
  showVideoControls = true,
  className,
}: VideoModulePropsModel) => {
  const [isMouseMoving, setIsMouseMoving] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(true);

  useEffect(() => {
    let timeout: any;
    const handleMouseMove = () => {
      setIsMouseMoving(true);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsMouseMoving(false);
      }, 30);
    };
    const handleTouchMove = () => {
      setIsMouseMoving(true);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleTouchMove);
      clearTimeout(timeout);
    };
  }, []);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
    }
  };

  useEffect(() => {
    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener("play", handlePlay);
      videoElement.addEventListener("pause", handlePause);
    }

    // Cleanup event listeners on component unmount
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handlePlay);
        videoElement.removeEventListener("pause", handlePause);
      }
    };
  }, []);

  return (
    <>
      <div className={cn("bg-core-black relative h-full w-full", className)}>
        {video && (
          <video
            ref={videoRef}
            src={video.url}
            controls={showVideoControls}
            autoPlay
            loop
            muted
            playsInline
            className="h-full w-full object-cover"
          />
        )}
        {video && (
          <div
            className={cn(
              !showVideoControls
                ? "!top-8 right-4 h-screen !transform-none md:right-8 lg:right-10"
                : "left-[50%]",
              "text-core-white absolute top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer mix-blend-difference will-change-transform",
            )}
          >
            {isPlaying ? (
              <AiOutlinePauseCircle
                size={showVideoControls ? 80 : 48}
                onClick={handlePlayPause}
                className={cn(showVideoControls ? "invisible" : "visible")}
              />
            ) : (
              <AiOutlinePlayCircle
                size={showVideoControls ? 80 : 48}
                onClick={handlePlayPause}
                className={cn(showVideoControls ? "invisible" : "visible")}
              />
            )}
          </div>
        )}
        {videoUrl && !video && (
          <div className="relative pb-[56.25%]">
            <iframe
              title={name}
              src={`${videoUrl}`}
              allowFullScreen
              scrolling="no"
              className="absolute top-0 left-0 h-full w-full overflow-hidden"
              style={{ pointerEvents: isMouseMoving ? "none" : "all" }}
            ></iframe>
          </div>
        )}
      </div>
    </>
  );
};

export default VideoModule;
